import { render, staticRenderFns } from "./certificateManagement.vue?vue&type=template&id=54f98fd4&scoped=true&"
import script from "./certificateManagement.vue?vue&type=script&lang=js&"
export * from "./certificateManagement.vue?vue&type=script&lang=js&"
import style0 from "./certificateManagement.vue?vue&type=style&index=0&id=54f98fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f98fd4",
  null
  
)

export default component.exports